<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 2.34375C6.89086 2.34375 2.34375 6.89086 2.34375 12.5C2.34375 18.1091 6.89086 22.6562 12.5 22.6562C18.1091 22.6562 22.6562 18.1091 22.6562 12.5C22.6562 6.89086 18.1091 2.34375 12.5 2.34375ZM13.2812 9.375C13.2812 8.94353 12.9315 8.59375 12.5 8.59375C12.0685 8.59375 11.7188 8.94353 11.7188 9.375V11.7188H9.375C8.94353 11.7188 8.59375 12.0685 8.59375 12.5C8.59375 12.9315 8.94353 13.2812 9.375 13.2812H11.7188V15.625C11.7188 16.0565 12.0685 16.4062 12.5 16.4062C12.9315 16.4062 13.2812 16.0565 13.2812 15.625V13.2812H15.625C16.0565 13.2812 16.4062 12.9315 16.4062 12.5C16.4062 12.0685 16.0565 11.7188 15.625 11.7188H13.2812V9.375Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPlusFill',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>